import { render } from "./TopArticle.vue?vue&type=template&id=5afcb13a&scoped=true"
import script from "./TopArticle.vue?vue&type=script&lang=js"
export * from "./TopArticle.vue?vue&type=script&lang=js"

import "./TopArticle.vue?vue&type=style&index=0&id=5afcb13a&lang=scss&scoped=true"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afcb13a"]])

export default __exports__